import { Router } from "next/router"
import { useRef } from "react"
import { ECommerceService } from "../machines/ecommerce-machine/e-commerce-machine"
import { useCheckUrlParamsV4 } from "./use-check-url-params-v4"
import { useHandleBrowserRefreshV4 } from "./use-handle-browser-refresh-v4"
import { useSyncStateWithUrlV4 } from "./use-sync-state-with-url-v4"

export const useUrlSyncV4 = (router: Router, ecommerce: ECommerceService) => {
    const isRestoreComplete = useRef<boolean>(false)

    useCheckUrlParamsV4(router)
    useHandleBrowserRefreshV4(isRestoreComplete, router, ecommerce)
    useSyncStateWithUrlV4(isRestoreComplete, router, ecommerce)
}
